/**
 * Agrupa un array de ítems por mes y año (multiperiodo).
 * Retorna grupos ordenados: más reciente primero (ej. Febrero 2026, Enero 2026, Diciembre 2025).
 * @param {Array} items - Array de ítems
 * @param {(item) => string|Date|null} getDate - Función que devuelve la fecha del ítem (ej. item => item.start_date)
 * @returns {{ key: string, label: string, year: number, month: number, items: Array }[]}
 */
const MONTH_NAMES = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

function parseDate(value) {
  if (!value) return null;
  const d = typeof value === 'string' ? new Date(value) : value;
  return isNaN(d.getTime()) ? null : d;
}

function getYearMonthKey(date) {
  const y = date.getFullYear();
  const m = date.getMonth() + 1;
  return `${y}-${String(m).padStart(2, '0')}`;
}

export function groupByMonthYear(items, getDate) {
  const map = new Map(); // key (YYYY-MM) -> { year, month, items }

  for (const item of items) {
    const dateVal = getDate(item);
    const date = parseDate(dateVal);
    const key = date ? getYearMonthKey(date) : '__sin_fecha__';
    if (!map.has(key)) {
      if (key === '__sin_fecha__') {
        map.set(key, { key, label: 'Sin fecha', year: 0, month: 0, items: [] });
      } else {
        const d = parseDate(dateVal);
        map.set(key, {
          key,
          label: `${MONTH_NAMES[d.getMonth()]} ${d.getFullYear()}`,
          year: d.getFullYear(),
          month: d.getMonth() + 1,
          items: []
        });
      }
    }
    map.get(key).items.push(item);
  }

  const groups = Array.from(map.values());
  // Ordenar: "Sin fecha" al final; el resto por año descendente, mes descendente (más reciente primero)
  groups.sort((a, b) => {
    if (a.key === '__sin_fecha__') return 1;
    if (b.key === '__sin_fecha__') return -1;
    if (a.year !== b.year) return b.year - a.year;
    return b.month - a.month;
  });

  return groups;
}
